module.exports = __webpack_public_path__ + "static/media/new-laptop.7c36fdcf.jpg";